import { useMemo } from 'react';

import { EventPricingTier } from 'legacy/common/types/models';
import { useRequestTierApproval } from '../../../../hooks';

/**
 * Hook that handles requesting screening approval for a specific event tier.
 */
const useRequestScreening = (
  eventId: string,
  tierIdRequiringApproval: string,
  ticketTiers: EventPricingTier[]
) => {
  const requestTierApproval = useRequestTierApproval();

  /**
   * Computes the questions to be consumed by the request approval form.
   */
  const questions = useMemo(() => {
    if (!tierIdRequiringApproval) {
      return [];
    }

    const approvalTierData = ticketTiers.find(
      (tier) => tier._id === tierIdRequiringApproval
    );

    return approvalTierData?.questions || [];
  }, [ticketTiers, tierIdRequiringApproval]);

  /**
   * Submits a request for tier approval.
   */
  const submitRequest = (values: Record<string, string>) =>
    new Promise((resolve, reject) => {
      const answers = Object.keys(values).map((question) => ({
        questionId: question,
        answer: values[question]
      }));

      requestTierApproval.mutate(
        {
          eventId,
          tierId: tierIdRequiringApproval,
          answers
        },
        {
          onSuccess: (data) => {
            resolve(data);
          },
          onError: (err) => {
            reject(err);
          }
        }
      );
    });

  return {
    questions,
    submitRequest,
    error: requestTierApproval.error
  };
};

export default useRequestScreening;
